<template>
  <v-flex xs12 md9>
    <cld-video :publicId="videoProviderId" width="100%" controls="true" class="mb-4">
      <cld-transformation width="1024" crop="scale"/>
    </cld-video>
  </v-flex>
</template>

<script>
export default {

  name: 'estateVideoSection',

  props: {
    video: {
      type: [Object, String],
      default: () => ({ provider_id: '', extra_data: '' })
    }
  },

  computed: {
    videoProviderId () {
      if (!this.video) return ''
      return typeof this.video === 'string' ? this.video : (this.video.provider_id || '')
    }
  }
}
</script>
